import { ObservableSocket } from "@game.object/ts-game-toolbox/dist/src/signals/ObservableSocket";
import p5 from "p5";
import { GameController } from "../base/GameController";
import { View } from "./View";

export class ViewMyNumberIsHigher extends View {
    public constructor(public p: p5, protected controller: GameController) {
        super();
    }

    public load() {
        document.addEventListener("keypress", this.on_keypress_func);
    }

    public unload() {
        document.removeEventListener("keypress", this.on_keypress_func);
    }

    public draw() {
        this.p.background(0);
        this.p.stroke(255);
        this.p.textSize(32);
        this.p.text("No, the number i have in mind is higher", 200, 300);
    }

    private on_keypress_func = (event: KeyboardEvent): void => {
        if (event.key === "Enter") {
            this.controller.ask_for_number();
            return;
        }
    };
}